// extracted by mini-css-extract-plugin
export default {"filter-column-height":"SummaryFilterBox_filter-column-height__D6eSx","ipad-pro-filterbox":"SummaryFilterBox_ipad-pro-filterbox__myqrL"};